import { DEFAULT_INITIAL_SEARCH_DATA } from "@saleor/config";
import { configurationMenuUrl } from "@saleor/configuration";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { registerListPath } from "@saleor/register/urls";
import useVoucherSearch from "@saleor/searches/useVoucherSearch";
import React from "react";
import { useIntl } from "react-intl";

import RecommendPopupPage, {
  RecommendPopupPageFormData
} from "../components/RecommendPopupPage";
import {
  useRecommendEmailSendTestMutation,
  useRecommendPopupDefaultCreateMutation,
  useRecommendPopupUpdateMutation
} from "../mutations";
import { useRecommendPopupQuery } from "../queries";
import { RecommendPopupUrlQueryParams } from "../urls";

export interface RecommendPopupProps {
  params: RecommendPopupUrlQueryParams;
}

const RecommendPopup: React.FC<RecommendPopupProps> = ({}) => {
  const { data, loading, refetch } = useRecommendPopupQuery({});
  const id = data?.recommendPopup?.id;
  const notify = useNotifier();
  const navigate = useNavigator();

  const intl = useIntl();

  const [defaultCreate] = useRecommendPopupDefaultCreateMutation({
    onCompleted: data => {
      if (data.recommendPopupDefaultCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Default Popup Created"
          })
        });
        refetch();
      }
    }
  });
  const [
    recommendPopupUpdate,
    recommendPopupUpdateOpts
  ] = useRecommendPopupUpdateMutation({
    onCompleted: data => {
      if (data.recommendPopupUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        refetch();
      }
    }
  });
  const handleSubmit = async (data: RecommendPopupPageFormData) => {
    const input = {
      ...data
    };
    const result = await recommendPopupUpdate({
      variables: {
        id,
        input
      }
    });
    return result.data.recommendPopupUpdate.errors;
  };

  const {
    search: fromSearch,
    loadMore: fromLoadMore,
    result: fromResult
  } = useVoucherSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  const {
    search: recommendSearch,
    loadMore: recommendLoadMore,
    result: recommendResult
  } = useVoucherSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });

  const [sendEmailTest] = useRecommendEmailSendTestMutation({
    onCompleted: data => {
      if (data.recommendEmailSendTest.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Test message sent."
          })
        });
      }
    }
  });

  return (
    <>
      <RecommendPopupPage
        recommendPopup={maybe(() => data.recommendPopup)}
        createDefault={() => defaultCreate({})}
        onBack={() => navigate(configurationMenuUrl)}
        onTest={() => sendEmailTest({})}
        disabled={loading}
        onSubmit={handleSubmit}
        saveButtonBarState={recommendPopupUpdateOpts.status}
        fromVouchersList={(fromResult.data?.search.edges || []).map(
          edge => edge.node
        )}
        showEvent={() => navigate(registerListPath)}
        fromFetchVouchers={fromSearch}
        fromFetchMoreVouchers={{
          hasMore: fromResult.data?.search.pageInfo.hasNextPage,
          loading: fromResult.loading,
          onFetchMore: fromLoadMore
        }}
        recommendVouchersList={(recommendResult.data?.search.edges || []).map(
          edge => edge.node
        )}
        recommendFetchVouchers={recommendSearch}
        recommendFetchMoreVouchers={{
          hasMore: recommendResult.data?.search.pageInfo.hasNextPage,
          loading: recommendResult.loading,
          onFetchMore: recommendLoadMore
        }}
      />
    </>
  );
};

export default RecommendPopup;
